import { apiSlice } from '../../app/api/apiSlice'

export const metadataApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSKUMetadata: builder.query ({
      query: (sku_id) => `v2/skumetadata/?SKU=${sku_id}&ordering=key`,
      keepUnusedDataFor: 1,
      providesTags: ["SKUMetadata"]
    }),
    updateMetadata: builder.mutation ({
      query: ({skumetadata_id, data}) => ({
        url: `v2/skumetadata/${skumetadata_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["SKUMetadata"]
    }),
    deleteMetadata: builder.mutation ({
      query: (skumetadata_id) => ({
        url: `v2/skumetadata/${skumetadata_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["SKUMetadata"]
    }),
    createMetadata: builder.mutation ({
      query: (data) => ({
        url: `v2/skumetadata/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["SKUMetadata"]
    }),

  }),
})


export const {
  useGetSKUMetadataQuery,
  useUpdateMetadataMutation,
  useDeleteMetadataMutation,
  useCreateMetadataMutation
} = metadataApi
